import { AxiosInstance, AxiosResponse } from 'axios';
import { INSTRUCTOR_TIMETABLE, ROOM_TIMETABLE, SET_TIMETABLE } from '../../constants';
import createTimetablesWebApiHttpClient from '../../api/createTimetablesWebApiHttpClient';
import { getExpUrl } from '../../helpers/api-url';

export class ExportExcelService {
    
    private readonly httpClient: AxiosInstance;

    constructor() {
        this.httpClient = createTimetablesWebApiHttpClient();
    }

    async downloadExcelSheet(type: string, termLabel: string, termSchoolID: number, week: number, setting) {
        let response: AxiosResponse | undefined = undefined;
        
        switch (type) {
            case SET_TIMETABLE:
                response = await this.downloadSetExcelSheet(setting.id, termSchoolID, week);
                break;

            case INSTRUCTOR_TIMETABLE:
                response = await this.downloadInstructorExcelSheet(setting.id, termSchoolID, week);
                break;

            case ROOM_TIMETABLE:
                response = await this.downloadRoomExcelSheet(setting.id, termSchoolID, week);
                break;
        }
            
        const fileName = this.generateFileName(type, termLabel, setting);
        this.download(fileName, response!);
    }

    private async downloadSetExcelSheet(setID: number, termSchoolID: number, week: number) {
        return await this.httpClient.get(`/Export/SetTimetable?setID=${setID}&termSchoolID=${termSchoolID}&week=${week}`, { responseType: 'blob' });
    }

    private async downloadInstructorExcelSheet(instructorID: number, termSchoolID: number, week: number) {
        return await this.httpClient.get(`/Export/InstructorTimetable?instructorID=${instructorID}&termSchoolID=${termSchoolID}&week=${week}`, { responseType: 'blob' });
    }

    private async downloadRoomExcelSheet(roomID: number, termSchoolID: number, week: number) {
        return await this.httpClient.get(`/Export/RoomTimetable?roomID=${roomID}&termSchoolID=${termSchoolID}&week=${week}`, { responseType: 'blob' });
    }

    private download(fileName: string, response: AxiosResponse) {
        const blob = new Blob([response.data]);
        const url = URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        
        downloadLink.href = url;
        downloadLink.download = fileName;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    private generateFileName(type: string, termLabel: string, settings) {
        switch (type) {
            case SET_TIMETABLE:
                return `Set_${settings.setCode.trim()}_${termLabel}.xlsx`;
            
            case INSTRUCTOR_TIMETABLE:
                return `Instructor_${settings.name.trim()}_${termLabel}.xlsx`;
            
            case ROOM_TIMETABLE:
                return `Room_${settings.roomNumber.trim()}_${termLabel}.xlsx`;

            default:
                return `${termLabel}.xlsx`;
        }
    }
}